import React, { useState, useEffect, useRef } from 'react'
import { Routes, Route, useNavigate, useLocation, useParams } from 'react-router-dom'
import '../css/Patientdashboard.css'
import SecInsurance from '../pages/SecInsurance'
import PrimaryInsurance from '../pages/PrimaryInsurance'
import PatientDashboard from '../pages/PatientDashboard'
import Notes from '../pages/Notes'
import Appointment from '../pages/Appointment'
import { useSelector } from 'react-redux'
import { APIConstants, CommonAPIConstants } from '../utilities/Constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash, faFilePdf } from '@fortawesome/free-regular-svg-icons'
import { faSpinner, faXmark, faArrowsRotate } from '@fortawesome/free-solid-svg-icons'
import { formatDOSDate } from '../utilities/Constants'

const MessagingPage = () => {

  const { id } = useParams()
  const sAuthToken = useSelector((state) => state.user.token)
  const DemoGraphyData = useSelector((state) => state.user.demoDetails);
  const [message, setMessage] = useState('')
  const [sent, setSent] = useState(false)
  const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
  const [text, settext] = useState("");

  const handleSend = () => {
    if (!message.trim()) return
    setSent(true)
    setMessage('')
  }

  const handleCloseModals = () => {

    setShowConfirmSaveModal(false);

  };


  const handleSavePatientMessage = async () => {

    const inputJson = {

      ToPhone: DemoGraphyData?.CellMainPhone,
      Message: text,
      CountryCode: "+1",

    }


    const sInputJSON = JSON.stringify(inputJson);

    try {


      const response = await fetch(APIConstants.SERVICES_URL + CommonAPIConstants.SavePatientMessage, {
        method: 'POST',


        headers: {

          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`,

        },

        body: sInputJSON
      })


      if (response.ok) {
        const responseData = await response.json();
        setShowConfirmSaveModal(true)
        console.log("RespData of", responseData);

      } else {
        console.error('Error sending data to the API');

      }



    } catch (error) {
      console.error('An error occurred:', error);

    }

  }

  return (
    <>
      <div className="message-card">
        <div className="message-header">
          <span>
            New Message - <span className="phone-number"> {DemoGraphyData?.CellMainPhone || "--"}</span>
          </span>
        </div>

        <div className="message-body">
          <textarea
            className="message-textarea"
            placeholder="Type a message..."
            value={text}
            onChange={(e) => settext(e.target.value)}
          />

        </div>

        <button className="send-btn" onClick={handleSavePatientMessage}>
          Send Now
        </button>

      </div>

      {showConfirmSaveModal && (

        <div className='alertcpt-modal'>
          <label></label>
          <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
          <p>Meesage Sent...</p>

        </div>

      )}
    </>
  )
}



const PatientLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [isShowPswd, setIsShowPswd] = useState(false);
  const { id } = useParams()
  const sAuthToken = useSelector((state) => state.user.token)
  const DemoGraphyData = useSelector((state) => state.user.demoDetails);
  const userData = useSelector((state) => state.user.user);
  var userPracticeID = userData ? userData.practiceID : null;


  useEffect(() => {


    if (DemoGraphyData?.username) {
      setUsername(DemoGraphyData.username)
    }
    if (DemoGraphyData?.password) {
      setPassword(DemoGraphyData.password)
    }

    if (DemoGraphyData?.Email1) {
      setEmail(DemoGraphyData.Email1)
    }

  }, [DemoGraphyData]);

  const handleSavePatCredentials = async () => {

    const inputJson = {
      patientID: id,
      practiceID: userPracticeID,
      sPatUserName: username,
      sPatPassword: password,
      sEmail: email,
      isFromInstantMeeting: 0

    }

    const myInput = JSON.stringify(inputJson);
    const sInputJSON = JSON.stringify(myInput);

    try {


      const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.SavePatientCredentials, {
        method: 'POST',
        headers: {

          'Accept': 'application/json',
          'Content-Type': 'application/json',

        },

        body: sInputJSON
      })


      if (response.ok) {
        const responseData = await response.json();
        window.location.reload();
        console.log("RespData of", responseData);

      } else {
        console.error('Error sending data to the API');

      }


    } catch (error) {
      console.error('An error occurred:', error);

    }

  }




  return (
    <>
      <div className="portal-card">
        <div className="portal-title">
          Patient Portal Credentials
        </div>

        <div className="portal-row">
          <div className="portal-field">
            <label>USERNAME</label>

            <input type="text" value={username} autocomplete="off"
              onChange={(e) => setUsername(e.target.value)} />
          </div>

          <div className="portal-field">
            <label>PASSWORD</label>

            <div className="password-wrapper">
              <input type={isShowPswd ? "text" : "password"} value={password} autocomplete="off"
                onChange={(e) => setPassword(e.target.value)} />


              {isShowPswd ? (

                <FontAwesomeIcon className='eye-icon'
                  icon={faEyeSlash}
                  aria-hidden="true"
                  onClick={() => {
                    setIsShowPswd(!isShowPswd)
                  }}
                  style={{ cursor: 'pointer' }}

                />
              ) : (
                <FontAwesomeIcon className='eye-icon'
                  icon={faEye}
                  aria-hidden="true"
                  onClick={() => {
                    setIsShowPswd(!isShowPswd)
                  }}
                  style={{ cursor: 'pointer' }}

                />
              )}
            </div>
          </div>
        </div>

        <div className="portal-field email-field">
          <label>EMAIL</label>
          <input type="email" value={email}
            onChange={(e) => setEmail(e.target.value)} />
        </div>

        <div className="portal-actions">
          <button className="preview-btn">
            👁 Preview Portal
          </button>

          <button className="save-btn" onClick={handleSavePatCredentials}>
            Save Credentials
          </button>
        </div>
      </div>

      <div className="portal-note">
        <strong>Note:</strong> Patient portal credentials allow the patient to
        log in and view appointments, messages, and lab results.
      </div>
    </>
  )
}



const PatDashboard = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const [activeTab, setActiveTab] = useState('ledger')
  const [insuranceData, setInsuranceData] = useState([])
  const [primaryInsData, setPrimaryInsData] = useState([])
  const [secondaryInsData, setSecondaryInsData] = useState([])
  const [showEditDemo, setShowEditDemo] = useState(false)
  const [selectedLocation, setSelectedLocation] = useState("");
  const [address, setAddress] = useState("");
  const [cell, setCell] = useState("");
  const [zip, setZip] = useState("");
  const [city, setCity] = useState('');
  const [stateName, setStateName] = useState('');
  const [zipError, setZipError] = useState('');
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [isDuplicateData, setIsDuplicateData] = useState([]);
  const [locations, setLocations] = useState([]);
  const [alerts, setAlerts] = useState('')
  const [showDuplicateTooltip, setShowDuplicateTooltip] = useState(false);
  const [errorMessages, setErrorMessages] = useState({
    cell: "",
    address: "",
    zip: "",
  });
  const [saveStatus, setSaveStatus] = useState({
    cell: null,
    saddress: null,
    zip: null,
  });

  const { id } = useParams()
  const sAuthToken = useSelector((state) => state.user.token)
  const DemoGraphyData = useSelector((state) => state.user.demoDetails);
  console.log('Demography Data in PatDashboard:', DemoGraphyData);
  const rosterIndicator = DemoGraphyData?.RosterIndicator;
  const rosterName = DemoGraphyData?.RosterName || "";
  const displayName = rosterIndicator === "R" ? rosterName : "Outpatient";
  const isDischarged = DemoGraphyData?.IsDischarged === 1;

  const userData = useSelector((state) => state.user.user);
  var userId = userData ? userData.userID : null;

  var userPracticeID = userData ? userData.practiceID : null;

  // const claimId = useSelector((state) => state.user.claimId);

  useEffect(() => {
    const currentTab = location.pathname.split('/').pop()

    if (['biller-dashboard', 'primary-insurance', 'secondary-insurance', 'notes', 'appointments', 'messaging', 'login'].includes(currentTab)) {
      setActiveTab(currentTab)
    } else if (id) {
      setActiveTab('primary-insurance')
      navigate(`/patientdashboard/${id}/primary-insurance`, { replace: true })
    }
  }, [location, id, navigate])



  const tooltipRef = useRef(null);
  const phoneInputRef = useRef(null);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        phoneInputRef.current &&
        !phoneInputRef.current.contains(event.target) &&
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target)
      ) {
        setShowDuplicateTooltip(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (DemoGraphyData?.Address1) {
      setAddress(DemoGraphyData.Address1);
    }

    if (DemoGraphyData?.Zip) {
      setZip(DemoGraphyData.Zip);
    }

    if (DemoGraphyData?.CellMainPhone) {
      setCell(DemoGraphyData.CellMainPhone);
    }

    if (DemoGraphyData?.LocationID) {
      setSelectedLocation(DemoGraphyData.LocationID);
    }
    if (DemoGraphyData?.CityName) {
      setCity(DemoGraphyData.CityName)
    }
    if (DemoGraphyData?.StateName) {
      setStateName(DemoGraphyData.StateName)
    }


  }, [DemoGraphyData]);



  useEffect(() => {
    if (!id) return

    const fetchPatInsurance = async () => {
      try {
        const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatInsuranceDetails}?PatientId=${id}`
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sAuthToken}`
          }
        })

        if (response.status !== 200) {
          console.log('response.status', response.status)
          return
        }

        const data = await response.json()
        const parsedData = typeof data === 'string' ? JSON.parse(data) : data
        setInsuranceData(parsedData)
        const filterData = parsedData.filter((item) => item.InsType == 2)
        const primaryData = parsedData.filter((item) => item.InsType == 1)
        setPrimaryInsData(primaryData)
        setSecondaryInsData(filterData)
        console.log('GetPrimaryInsurance of' + CommonAPIConstants.GetPatInsuranceDetails, filterData)
      } catch (error) {
        console.error('Error fetching:', error)
      }
    }

    fetchPatInsurance()
  }, [id, sAuthToken])



  const getFirstWord = (text) => {
    if (!text) return "--";
    return text.toString().trim().split(/\s+/)[0] || "--";
  };

  const primaryInsCoLabel = getFirstWord(primaryInsData?.[0]?.InsCoName);
  const secondaryInsCoLabel = getFirstWord(secondaryInsData?.[0]?.InsCoName);

  const handleTabClick = (tab) => {
    setActiveTab(tab)
    if (id) {
      navigate(`/patientdashboard/${id}/${tab}`)
    }
  }


  const formatDOBDate = (dateString) => {
    if (!dateString) {
      return "";
    }


    const specificDate = new Date("01/01/1900");
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return "";
    }


    if (date.getTime() === specificDate.getTime()) {
      return "";
    }

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  };

  const onClose = () => {
    setShowEditDemo(false)
  }






  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, '').slice(0, 10);
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (!match) return value;
    const [, area, prefix, line] = match;
    let result = '';
    if (area) result = `(${area}`;
    if (prefix) result += `) ${prefix}`;
    if (line) result += `-${line}`;
    return result;
  };

  useEffect(() => {
    if (!showEditDemo) return;

    setCell(formatPhoneNumber(DemoGraphyData?.CellMainPhone || ""));
    setAddress(DemoGraphyData?.Address1 || "");
    setZip(DemoGraphyData?.Zip || DemoGraphyData?.ZipCode || "");
  }, [showEditDemo, DemoGraphyData]);




  const handlePhoneInputChange = (e) => {
    const value = e.target.value;
    setCell(value);

    if (
      isDuplicate &&
      value.replace(/\D/g, "").length === 10 &&
      isDuplicateData.length > 0
    ) {
      setShowDuplicateTooltip(true);
    }
  };


  const validateField = (field, value) => {
    const raw = value.replace(/\D/g, '');

    switch (field.toLowerCase()) {
      case 'cell':
        return raw.length === 10 ? '' : 'Phone number must be 10 digits';

      case 'zip':
        return /^\d{5}$/.test(value) ? '' : 'Zip code must be exactly 5 digits';

      case 'address':
        return value.trim().length >= 5
          ? ''
          : 'Address must be at least 5 characters long';

      default:
        return '';
    }
  };


  //Save The Patient Contact Number
  const debounceContactTimeout = useRef(null);


  const handleSaveContact = async (field, contact, eventName) => {

    const raw = contact.replace(/\D/g, '');
    if (raw.length == 10) {
      await handleCheckisDuplicatePhoneNumber(raw);
    } else {
      setIsDuplicate(false);
      setIsDuplicateData([]);
    }
    if (raw.length > 10) {
      setErrorMessages((prev) => ({
        ...prev,
        cell: 'Phone number must be 10 digits',
      }));
      return;
    }

    const errorMessage = validateField(field, contact);

    switch (field) {
      case 'cell':
        setCell(formatPhoneNumber(raw));
        setErrorMessages((prev) => ({ ...prev, cell: '' }));
        break;
      case 'address':
        setAddress(contact);
        break;
      case 'zip':
        setZip(contact);
        break;
      default:
        break;
    }

    setErrorMessages((prev) => ({ ...prev, [field]: errorMessage }));

    if (debounceContactTimeout.current) {
      clearTimeout(debounceContactTimeout.current);
    }



    debounceContactTimeout.current = setTimeout(async () => {

      const inputJson = {
        PracticeID: userPracticeID,
        PatientID: id,
        ContactNumber: formatPhoneNumber(raw)
      }


      const sInput = JSON.stringify({ PatInfo: inputJson })
      const JsonInput = JSON.stringify(sInput)

      try {

        if (eventName.type === "blur") {
          const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.SaveContactNumber, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sAuthToken}`
            },
            body: JsonInput
          });

          const data = await response.json();

          // if (data) {

          //   window.location.reload();
          // }
        }


      } catch (error) {
        console.error("Error saving notes:", error);
      }
    }, 500)
  };



  const handleCheckisDuplicatePhoneNumber = async (phoneNumber) => {
    const inpuJson = {
      sPhoneNumber: phoneNumber || cell,
      sPatientID: id,
      sPracticeID: userPracticeID,
    };

    const sInputJSON = JSON.stringify(inpuJson);
    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.CheckisDuplicatePhoneNumber}?sInputJSON=${sInputJSON}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`,
        },
      });

      if (response.status !== 200) {
        console.log('response.status', response.status);
        return false;
      }

      const data = await response.json();
      setIsDuplicateData(data.duplicates);
    
      if (data.totalDuplicates > 0 && Array.isArray(data.duplicates)) {
        setIsDuplicate(true);
        setIsDuplicateData(data.duplicates);
        return true;
      }

      setIsDuplicate(false);
      setIsDuplicateData([]);
      return false;
    } catch (error) {
      console.error('Error fetching:', error);
      setIsDuplicate(false);
      setIsDuplicateData([]);
      return false;
    }
  }





  useEffect(() => {
    handleCheckisDuplicatePhoneNumber();
  }, [cell]);




  //Save The Patient Address
  const debounceAddrtTimeout = useRef(null);


  const handleSaveAddress = async (field, address, eventName) => {

    const errorMessage = validateField(field, address);
    switch (field) {
      case "cell":
        setCell(address);
        break;
      case "address":
        setAddress(address);
        break;
      case "zip":
        setZip(address);
        break;
      default:
        break;
    }

    setErrorMessages((prev) => ({ ...prev, [field]: errorMessage }));

    if (debounceAddrtTimeout.current) {
      clearTimeout(debounceAddrtTimeout.current);
    }



    debounceAddrtTimeout.current = setTimeout(async () => {

      const inputJson = {
        PracticeID: userPracticeID,
        PatientID: id,
        Address: address
      }


      const sInput = JSON.stringify({ PatInfo: inputJson })
      const JsonInput = JSON.stringify(sInput)
      console.log("input of" + CommonAPIConstants.SavePatAddress, JsonInput);


      try {

        if (eventName.type === "blur") {
          const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.SavePatAddress, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sAuthToken}`
            },
            body: JsonInput
          });

          const data = await response.json();

        }


      } catch (error) {
        console.error("Error saving notes:", error);
      }
    }, 500)
  };





  //Save The Patient Address
  const debounceZipTimeout = useRef(null);


  const handleSaveZip = async (field, Zip, eventName) => {

    const normalizedField = field.toLowerCase();
    const errorMessage = validateField(normalizedField, Zip);


    if (errorMessage) {
      setErrorMessages((prev) => ({ ...prev, [normalizedField]: errorMessage }));
      return;
    }

    if (normalizedField === "zip") {
      await handleGeZipDetails(normalizedField, Zip);
    }



    switch (normalizedField) {
      case "cell":
        setCell(Zip);
        break;
      case "address":
        setAddress(Zip);
        break;
      case "zip":
        setZip(Zip);
        break;
      default:
        break;
    }

    setErrorMessages((prev) => ({ ...prev, [normalizedField]: '' }));


    if (debounceZipTimeout.current) {
      clearTimeout(debounceZipTimeout.current);
    }



    debounceZipTimeout.current = setTimeout(async () => {

      const inputJson = {
        PracticeID: userPracticeID,
        PatientID: id,
        Zip: Zip
      }


      const sInput = JSON.stringify({ PatInfo: inputJson })
      const JsonInput = JSON.stringify(sInput)
      console.log("input of" + CommonAPIConstants.SaveZipDetails, JsonInput);


      try {

        if (eventName.type === "blur") {
          const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.SaveZipDetails, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sAuthToken}`
            },
            body: JsonInput
          });

          const data = await response.json();
          // if (data) {

          //   window.location.reload();
          // }
          console.log("Response of" + CommonAPIConstants.SaveZipDetails, data);

        }


      } catch (error) {
        console.error("Error saving notes:", error);
      }
    }, 500)
  };




  const handleGeZipDetails = async (field, Zip, eventName) => {
    if (field !== "zip") return;

    try {
      const zipPayload = JSON.stringify({ zipcode: Zip });
      const response = await fetch(APIConstants.BASE_URL + CommonAPIConstants.GetZipDetails, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: zipPayload
      });

      const zipData = await response.json();
      const parsedData = JSON.parse(zipData.d);

      if (parsedData && parsedData.cityName && parsedData.StateShortDesc) {

        console.log("CITY >>>>>>>>>>>>>>", parsedData, parsedData.StateShortDesc);

        setCity(parsedData.cityName);
        setStateName(parsedData.StateShortDesc);
        setZipError('');
      } else {
        setCity('');
        setStateName('');
        setZipError('Incorrect Zipcode');
      }
    } catch (zipError) {
      console.error("Error fetching city/state:", zipError);
      setZipError('Invalid ZIP');
      setCity('');
      setStateName('');
    }
  };




  const handleUpdateLocation = async (e) => {
    const selectedValue = e.target.value
    setSelectedLocation(selectedValue);

    const inpuJson = {

      sPatID: DemoGraphyData.PatientId,
      sAppDate: formatDOSDate(userData.dtCurrentWorkingDate),
      sPatLoc: selectedValue,
      sPracticeID: userPracticeID,
      sUserID: userId,
      sUserFullName: userData.userFullName,
      sUserRole: userData.roleID,


    }

    const myInput = JSON.stringify(inpuJson);
    const inputData = JSON.stringify(myInput)

    try {
      const response = await fetch(APIConstants.BASE_URL_APPOINTMENT_MS + CommonAPIConstants.UpdatePatLocation, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sAuthToken}`,

        },
        body: inputData
      })



      if (response.status !== 200) {
        console.log("Error: Received response status", response.status);
        return;
      }



      const responseData = await response.json();


    } catch (error) {
      console.error('An error occurred:', error);
    }
  };






  const getLocation = () => {


    const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetLocationDetails}?sInputJSON={"PracticeID":${userPracticeID}}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })

      .then((res) => {
        const parsedData = JSON.parse(res)


        setLocations(parsedData)
      })
      .catch((err) => {
        console.error("Error occurred while fetching location")
      });
  };




  useEffect(() => {

    getLocation();

  }, []);


  const handleAllChanges = () => {
    setShowEditDemo(false)
    window.location.reload();
  }



  const formatDate = (date) => {
    const d = new Date(date);
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const getAlerts = async () => {
    const formattedDate = formatDate(new Date());

    const inputObj = {
      PatientID: id,
      sCurrentWorkingDate: formattedDate
    };

    const sInputJSON = encodeURIComponent(JSON.stringify(inputObj));

    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientAlertNotes}?sInputJSON=${sInputJSON}`;

    console.log("Final URL:", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })
      .then((response) => {
        console.log("Status:", response.status);

        if (!response.ok) throw new Error("API failed");

        return response.json();
      })
      .then((res) => {

        setAlerts(res);
      })
      .catch((error) => {
        console.error('Error fetching Alert:', error);
      });
  };



  // Save the Alerts Text
  const debounceAleartTimeout = useRef(null);

  const saveAlerts = async (alertText, eventName) => {
    const date = new Date()

    if (debounceAleartTimeout.current) {
      clearTimeout(debounceAleartTimeout.current);
    }


    debounceAleartTimeout.current = setTimeout(async () => {



      const input = JSON.stringify(JSON.stringify({
        PatientID: id,
        PracticeID: userPracticeID,
        IsShared: 1,
        Notes: alertText,
        noteText: alertText,
        UserID: userId,
        sCurrentWorkingDate: date
      }));


      try {

        if (eventName.type === "blur") {
          const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.SavePatientAlertNotes, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sAuthToken}`
            },
            body: input
          });

          const data = await response.json();


        }

      } catch (error) {
        console.error("Error saving notes:", error);

      }

    }, 500)

  };



  useEffect(() => {

    getAlerts()


  }, [id])

  return (
    <div className="patient-dashboard" style={{ display: 'block' }}>

      {/* Header */}
      <div className="patient-header">
        <div className="patient-avatar">
          {DemoGraphyData?.LastName?.charAt(0) || " "}
        </div>

        <div className="patient-content">
          <div className="patient-top-row">
            <h3 className="patient-name">
              {DemoGraphyData?.LastName}, {DemoGraphyData?.FirstName}
            </h3>
            <span className="patient-id">
              {DemoGraphyData?.MRN}
            </span>
            <span className="patient-id">
              {DemoGraphyData?.PatientID}
            </span>

            <span
              className={`status-pill ${isDischarged ? "status-discharged" : "status-active"
                }`}
            >
              ● {isDischarged ? "Discharged" : "Active"}
            </span>

            <span className="type-pill">
              {displayName || "Outpatient"}
            </span>
          </div>

          <div className="patient-info-row">
            <span>
              <strong>DOB:</strong> {formatDOBDate(DemoGraphyData?.DOB)}
            </span>

            <span>
              <strong>Cell:</strong> {DemoGraphyData?.CellMainPhone || "--"}
            </span>

            <span>
              <strong>Email:</strong> {DemoGraphyData?.Email1 || "--"}
            </span>

            <span>
              <strong>Address:</strong> {DemoGraphyData?.Address1 || "--"}
            </span>


          </div>
        </div>
      </div>


      <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 8, padding: "8px 14px" }}>

        <div style={{ background: "#fff", borderRadius: 9, padding: "11px 14px", border: "1px solid #ddd", borderLeft: "4px solid red" }}>
          <div style={{ fontSize: 15, fontWeight: 600, color: "red", letterSpacing: 0.5, marginBottom: 6 }}>Alert !</div>
          <textarea
            rows="4"
            cols="44"
            className="border border-gray-300 m-1 rounded-md text-red-600 w-100"
            defaultValue={alerts}
            onBlur={(e) => saveAlerts(e.target.value, e)}
          />
        </div>


        <div style={{ background: "#fff", borderRadius: 9, padding: "11px 14px", border: "1px solid #ddd", borderLeft: "4px solid #e8812a" }}>
          <div style={{ fontSize: 10, fontWeight: 600, color: "#aaa", letterSpacing: 0.5, marginBottom: 6 }}>ACTIVE INSURANCE</div>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#1a1a1a" }}>{insuranceData.length} Active Plans</div>
          <div style={{ fontSize: 11, color: "#777", marginTop: 3 }}>{primaryInsData.length} Primary · {secondaryInsData.length} Secondary</div>

          <div style={{ marginTop: 6 }}><span style={{ background: "#fff3e0", color: "#e65100", fontSize: 10, fontWeight: 500, padding: "1px 8px", borderRadius: 10 }}>
            {`${primaryInsCoLabel} · ${secondaryInsCoLabel}`}
          </span></div>
        </div>




      </div>


      {/* Body */}
      <div className="content-section">

        {/* Left Panel */}
        <div className="left-panel">

          <div className="panel-header">
            Demographics

            <button className="edit-btn" onClick={() => setShowEditDemo(true)}>
              Edit
            </button>
          </div>

          <div className="demo-row">
            <label>Status</label>
            <span>Active</span>
          </div>

          <div className="demo-row">
            <label>DOB</label>
            <span> {formatDOBDate(DemoGraphyData.DOB)}</span>
          </div>

          <div className="demo-row">
            <label>Age</label>
            <span>{DemoGraphyData.Age || ""}</span>
          </div>

          <div className="demo-row">
            <label>Address</label>
            <span>{DemoGraphyData.Address1}</span>
          </div>

          <div className="demo-row">
            <label>Cell</label>
            <span>{DemoGraphyData.CellMainPhone}</span>
          </div>

          <div className="demo-row">
            <label>Email</label>
            <span>{DemoGraphyData.Email1 || "_"}</span>
          </div>

          <div className="demo-row">
            <label>City</label>
            <span>{DemoGraphyData.CityName || "_"}</span>
          </div>

          <div className="demo-row">
            <label>State</label>
            <span>{DemoGraphyData.StateName || "_"}</span>
          </div>

        </div>

        {/* Right Panel */}
        <div className="right-panel">

          <div className="tabs">
            <button
              className={activeTab === 'primary-insurance' ? 'active' : ''}
              onClick={() => handleTabClick('primary-insurance')}
            >
              Primary Insurance
            </button>
            <button
              className={activeTab === 'secondary-insurance' ? 'active' : ''}
              onClick={() => handleTabClick('secondary-insurance')}
              style={{
                backgroundColor: secondaryInsData.length > 0 ? 'yellow' : undefined,
                color: secondaryInsData.length > 0 ? 'black' : undefined
              }}
            >
              Secondary Insurance
            </button>
            <button
              className={activeTab === 'biller-dashboard' ? 'active' : ''}
              onClick={() => handleTabClick('biller-dashboard')}
            >
              Ledger
            </button>
            <button className={activeTab === 'appointments' ? 'active' : ''}
              onClick={() => handleTabClick('appointments')}>Appointments

            </button>

            <button className={activeTab === 'notes' ? 'active' : ''}
              onClick={() => handleTabClick('notes')}>Notes</button>

            <button className={activeTab === 'messaging' ? 'active' : ''}
              onClick={() => handleTabClick('messaging')}>Messaging</button>

            <button className={activeTab === 'login' ? 'active' : ''}
              onClick={() => handleTabClick('login')}>Login</button>
          </div>

          <div className="tab-panel">
            <Routes>

              <Route path="primary-insurance" element={<PrimaryInsurance />} />
              <Route path="secondary-insurance" element={<SecInsurance />} />
              <Route path="biller-dashboard" element={<PatientDashboard />} />
              <Route path="appointments" element={<Appointment />} />
              <Route path="notes" element={<Notes />} />
              <Route path="messaging" element={<MessagingPage />} />
              <Route path="login" element={<PatientLogin />} />
            </Routes>
          </div>

        </div>

        {
          showEditDemo && (
            <>
              <div className="edit-demo-modal">
                <div className="edit-demo-header">
                  <h3>Edit Demographics</h3>
                  <button className="close-btn" onClick={onClose}>
                    ✕
                  </button>
                </div>

                <div className="edit-demo-body">


                  {/* CONTACT INFORMATION */}
                  <div className="section-title">CONTACT INFORMATION</div>

                  <div className="form-grid-3">
                    <div style={{ position: "relative" }}>
                      <label>Cell Phone</label>

                      <input
                        ref={phoneInputRef}
                        type="text"
                        value={cell}
                        className={`demo-input ${isDuplicate &&
                          cell.replace(/\D/g, "").length === 10 &&
                          isDuplicateData.length > 0
                          ? "duplicate-input"
                          : ""
                          }`}
                        onChange={handlePhoneInputChange}
                        onFocus={() => {
                          if (
                            isDuplicate &&
                            cell.replace(/\D/g, "").length === 10 &&
                            isDuplicateData.length > 0
                          ) {
                            setShowDuplicateTooltip(true);
                          }
                        }}
                        onBlur={(e) => handleSaveContact("cell", e.target.value, e)}
                        maxLength={14}
                      />

                      {showDuplicateTooltip &&
                        isDuplicate &&
                        cell.replace(/\D/g, "").length === 10 &&
                        isDuplicateData.length > 0 && (
                          <div ref={tooltipRef} className="duplicate-tooltip">
                            <strong>Duplicate Phone Number</strong>
                            <hr />
                            {isDuplicateData.map((item, index) => {
                              const fname = item.FirstName?.trim() || "";
                              const lname = item.LastName?.trim() || "";

                              return (
                                <div key={index} className="duplicate-name">
                                  {lname} {fname}
                                </div>
                              );
                            })}
                          </div>
                        )}
                    </div>

                    <div>
                      <label>Address1</label>
                      <input
                        type="text" className="demo-input"
                        defaultValue={address}
                        onBlur={(e) => handleSaveAddress("address", e.target.value, e)}
                      />
                    </div>

                    <div>
                      <label>Zip Code</label>
                      <input
                        type="text"
                        className="demo-input"
                        defaultValue={zip}
                        maxLength={5}
                        onBlur={(e) => handleSaveZip("zip", e.target.value.trim(), e)}
                      />
                    </div>


                    <div>
                      <label>City</label>
                      <input type="text" value={city} className="demo-input"
                        disabled />
                    </div>

                    <div>
                      <label>State</label>
                      <input type="text" value={stateName} className="demo-input"
                        disabled />
                    </div>

                    <div>
                      <label>Location</label>
                      <select className="demo-input"
                        value={selectedLocation}
                        onChange={(e) => handleUpdateLocation(e)}>

                        {locations.map((item, index) => (
                          <option style={{ width: "100px" }} value={item.LocationId} key={index}>{item.LocationNickname}</option>

                        ))}
                      </select>

                    </div>

                  </div>


                </div>

                <div className="edit-demo-footer">
                  <button className="btn-cancel" onClick={onClose}>Cancel</button>
                  <button className="btn-save" onClick={handleAllChanges}>Save Changes</button>
                </div>
              </div>
            </>
          )

        }

      </div>

    </div>
  )
}

export default PatDashboard